import {LeadModel, SuperBit_swaggerClient,LeadFilterModel, PolicyFilterModel,RenewalsSalespersonPolicies} from './superbit-api-models';
import generalSettings from '../json/general-settings.json';

export class PolicyModel {
    client:any;
    constructor() {
        this.init();
    }

    async fetchData () {
        let apiUrl = undefined;
        try {
            const response = await fetch('/config.json');
            const jsonData = await response.json();
            apiUrl = jsonData.apiUrl;
            localStorage.setItem('apiUrl', apiUrl)
            localStorage.setItem('appConfig', JSON.stringify(jsonData));
        } catch (error) {
            console.error('Error fetching data: ', error);
        }
        return apiUrl;
    };


    async init () {
        let apiUrl = localStorage.getItem('apiUrl');
        if (!apiUrl) {
            apiUrl = await this.fetchData();
        }
        var url = apiUrl ? apiUrl : generalSettings.apiUrl;
        //var url = "https://localhost:44333";
        //this.client = new SuperBit_swaggerClient("http://api.dev-alt.superbit.co.il");
        this.client = new SuperBit_swaggerClient(url);//(settings.apiUrl);
    }
    

    async policyGetById (id:string) {
        return await this.client.policyGetById(id);
        
    };

    async policyGetRoutesByConditions(body: any){
        return await this.client.policyGetRoutesByConditions(body);
    }

    async policyCreate(body: any){
        return await this.client.policyCreate(body);
    }

    async getElementaryInsurancePolicyId(policyId: string){
        return await this.client.getElementaryInsurancePolicyId(policyId);
    }

   
}